import { TableCell, TableRow } from "@egaranti/components";

import { useState } from "react";

import ReportTable from "./ReportTable";
import SortableSearchableTableDialog from "./SortableSearchableTableDialog";
import { useTranslation } from "react-i18next";

const StoreRankingTable = ({ data, loading }) => {
  const { t } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const displayData = data?.slice(0, 10) || [];

  const columns = [
    {
      key: "store",
      label: t("extendedWarranty.reports.stores.store", "Mağaza"),
      sortable: true,
      align: "left",
    },
    {
      key: "count",
      label: t("extendedWarranty.reports.stores.count", "Adet"),
      sortable: true,
      align: "right",
    },
    {
      key: "revenue",
      label: t("extendedWarranty.reports.stores.revenue", "Ciro"),
      sortable: true,
      align: "right",
    },
    {
      key: "avgPrice",
      label: t("extendedWarranty.reports.stores.averagePrice", "Ort. Fiyat"),
      sortable: true,
      align: "right",
    },
  ];

  const handleSearch = (item, query) => {
    const storeName = (item.labels?.[0] || "").toLowerCase();
    const count = (item.data?.[0] || "").toString().toLowerCase();
    const revenue = (item.totalRevenue || "").toLowerCase();
    const avgPrice = (item.avgRevenue || "").toLowerCase();

    return (
      storeName.includes(query) ||
      count.includes(query) ||
      revenue.includes(query) ||
      avgPrice.includes(query)
    );
  };

  const handleSort = (a, b, key, direction) => {
    let aValue, bValue;

    switch (key) {
      case "store":
        aValue = a.labels?.[0] || "";
        bValue = b.labels?.[0] || "";
        return direction === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      case "count":
        aValue = a.data?.[0] || 0;
        bValue = b.data?.[0] || 0;
        break;
      case "revenue":
        aValue = parseFloat(
          a.totalRevenue?.replace("₺", "").replace(",", "") || 0,
        );
        bValue = parseFloat(
          b.totalRevenue?.replace("₺", "").replace(",", "") || 0,
        );
        break;
      case "avgPrice":
        aValue = parseFloat(
          a.avgRevenue?.replace("₺", "").replace(",", "") || 0,
        );
        bValue = parseFloat(
          b.avgRevenue?.replace("₺", "").replace(",", "") || 0,
        );
        break;
      default:
        return 0;
    }

    return direction === "asc" ? aValue - bValue : bValue - aValue;
  };

  const renderCell = (item, key) => {
    const notAvailable = t("common.notAvailableShort", "N/A");
    switch (key) {
      case "store":
        return item.labels?.[0] || notAvailable;
      case "count":
        return item.data?.[0] || 0;
      case "revenue":
        return item.totalRevenue || "₺0";
      case "avgPrice":
        return item.avgRevenue || "₺0";
      default:
        return notAvailable;
    }
  };
  const tableColumns = [
    "#",
    t("extendedWarranty.reports.stores.store", "Mağaza"),
    t("extendedWarranty.reports.stores.count", "Adet"),
    t("extendedWarranty.reports.stores.revenue", "Ciro"),
    t("extendedWarranty.reports.stores.averagePrice", "Ort. Fiyat"),
  ];

  const renderRow = (store, index) => (
    <TableRow key={index}>
      <TableCell>{index + 1}</TableCell>
      <TableCell>{store.labels?.[0] || "N/A"}</TableCell>
      <TableCell>{store.data?.[0] || 0}</TableCell>
      <TableCell>{store.totalRevenue || "₺0"}</TableCell>
      <TableCell>{store.avgRevenue || "₺0"}</TableCell>
    </TableRow>
  );

  return (
    <div className="rounded-lg border bg-white">
      <div className="border-b p-6">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-medium text-[#111729]">
              {t(
                "extendedWarranty.reports.stores.title",
                "Mağaza Bazlı Satış Sıralaması",
              )}
            </h3>
            <p className="mt-1 text-sm text-[#677389]">
              {t(
                "extendedWarranty.reports.stores.description",
                "En çok satış yapan ilk 10 mağaza",
              )}
            </p>
          </div>
          {data && data.length > 10 && (
            <SortableSearchableTableDialog
              data={data}
              columns={columns}
              title={t(
                "extendedWarranty.reports.stores.dialogTitle",
                "Mağaza Bazlı Satış Sıralaması - Tüm Veriler",
              )}
              searchPlaceholder={t(
                "extendedWarranty.reports.stores.searchPlaceholder",
                "Mağaza, adet, ciro veya fiyat ara...",
              )}
              onSearch={handleSearch}
              onSort={handleSort}
              renderCell={renderCell}
              isOpen={isDialogOpen}
              onOpenChange={setIsDialogOpen}
            />
          )}
        </div>
      </div>
      <ReportTable
        data={displayData}
        loading={loading}
        columns={tableColumns}
        renderRow={renderRow}
        colSpan={5}
      />
    </div>
  );
};

export default StoreRankingTable;
